import * as React from 'react';

import { Spinner } from '@base/components/ui/Spinner';

import { ISpinnerBottomProps } from './types';

import * as s from './SpinnerBottom.scss';

export const SpinnerBottom: React.FC<ISpinnerBottomProps> = (props: ISpinnerBottomProps ) => {
	const {
		size = 16,
	} = props;

	return (
		<div className={s.block}>
			<Spinner
				className={s.spinner}
				size={size}
			/>
		</div>
	);
};

